const prefix = '@@KANDY/CONN/'

// Actions to tell connectivity plugin what to do
export const WS_ATTEMPT_CONNECT = prefix + 'WS_ATTEMPT_CONNECT'
export const WS_CONNECT_FINISHED = prefix + 'WS_CONNECT_FINISHED'
export const WS_DISCONNECT = prefix + 'WS_DISCONNECT'
export const WS_DISCONNECT_FINISHED = prefix + 'WS_DISCONNECT_FINISHED'
export const WS_RECONNECT_FAILED = prefix + 'WS_RECONNECT_FAILED'

// actions for hooking into connectivity plugin behaviour
export const WS_CLOSED = prefix + 'WS_CLOSED'
export const WS_ERROR = prefix + 'WS_ERROR'

export const LOST_CONNECTION = prefix + 'LOST_CONNECTION'

export const RECEIVE_SERVER_PING = prefix + 'RECEIVE_SERVER_PING'
export const RECEIVE_SERVER_PONG = prefix + 'RECEIVE_SERVER_PONG'

export const CHANGE_CONNECTIVITY_CHECKING = prefix + 'CHANGE_CONNECTIVITY_CHECKING'
export const CHANGE_PING_INTERVAL = prefix + 'CHANGE_PING_INTERVAL'
